import React, { Component } from 'react';
import './ApplyTalk.css';
import ApplyTalkStyles from '../components/ApplyTalkStyles';
import ImageLogo from '../images/logo.jpg';


export default class extends Component {
    componentDidMount(){
      document.title = "알림톡청구서 신청";
      this.getTokenInfo();
    }
    componentDidUpdate(prevProps, prevState){
      if (this.state.expires_at !== prevState.expires_at){
        var today = new Date();
        var expires_at = new Date(this.state.expires_at);
        if(today > expires_at) {
          this.setState({ ...this.state, expires_chk: true });
        }
      }
    }
    constructor() {
        super();
        this.state = {
          token: '',
          cust_no: '',
          cust_no_mask: '',
          cust_nm: '',
          channel_gb: '',
          expires_at: '',
          apply_yn: '',
          expires_chk: false,
          isLoading : true
        };
        this.stateRefresh = this.stateRefresh.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
      }
      stateRefresh() {
        this.setState({
          token: '',
          cust_no: '',
          cust_no_mask: '',
          cust_nm: '',
          channel_gb: '',
          expires_at: '',
          apply_yn: '',
          expires_chk: false,
          isLoading : true
        });
      }

      handleFormSubmit(event) {
        event.preventDefault();

        this.chkApplyResult();
      }

      getTokenInfo = async () => {
        const { params } = this.props.match;

        const response = await fetch('/api/applytalk/getTokenInfo?token='+params.token);
        const body = await response.json();

        body.forEach((dt) => {
            this.setState({ token: dt.TOKEN});
            this.setState({ cust_no: dt.CUST_NO});
            this.setState({ cust_no_mask: dt.CUST_NO_MASK});
            this.setState({ cust_nm: dt.CUST_NM});
            this.setState({ channel_gb: dt.CHANNEL_GB});
            this.setState({ expires_at: dt.EXPIRES_AT});
            this.setState({ apply_yn: dt.APPLY_YN});
        })
        this.setState({ isLoading: false});

        return body;
      }

      chkApplyResult = async () => {
        const { params } = this.props.match;

        const response = await fetch('/api/applytalk/checkApply', {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type' : 'application/json'
            },
            body: JSON.stringify({
                token: params.token,
                cust_no: this.state.cust_no
              })
            })
            
            const body = await response.json();

            body.forEach((dt) => {
                this.setState({ apply_exist: dt.CHK});
            })
            if(this.state.apply_exist){
                alert("이미 알림톡청구서 신청이 완료되었습니다.");
            }else{
                this.addApplyResult();
            }
            return body;
      }

      addApplyResult = async () => {
        const { params } = this.props.match;

        const response = await fetch('/api/applytalk/insertApply', {
          method: "post",
          headers: {
              'Accept': 'application/json',
              'Content-Type' : 'application/json'
          },
          body: JSON.stringify({
            token: params.token,
            cust_no: this.state.cust_no,
            channel_gb: this.state.channel_gb
            })
          })
          
          const t = await response.json();

          console.log(t);

          alert("알림톡청구서 신청이 완료되었습니다.");
      }
      
    render(){
      const { params } = this.props.match;
      var token = this.state.token;
      var apply_yn = this.state.apply_yn;
      var expires_chk = this.state.expires_chk;

      if(this.state.isLoading) {
        return null;
      } else {
        if(token === null || token === '') {
          return(
            <>
              <div className="div_logo">
                  <br />
                  <img width='150' src={ImageLogo} alt="대륜이엔에스 로고입니다." />
                  <br />
              </div>
              <div className="body center">
                <div>
                  <h1>토큰이 유효하지 않습니다.</h1>
                </div>
              </div>
            </>
          );
        } else {
          if(!expires_chk){
            if (apply_yn == 'Y') {
              return(
                <>
                <div className="div_logo">
                    <br />
                    <img width='150' src={ImageLogo} alt="대륜이엔에스 로고입니다." />
                    <br />
                </div>
                <div className="body center">
                  <div>
                    <h2 className="h2">도시가스요금 알림톡청구서 신청</h2>
                    <h3 className="h3">&nbsp;이미 알림톡청구서 신청이 완료되었습니다.</h3>
                  </div>
                </div>
              </>
              )
            } else {
              return (
                <form onSubmit={this.handleFormSubmit}>
                    <div className="div_logo">
                      <br />
                      <img width='150' src={ImageLogo} alt="대륜이엔에스 로고입니다." />
                      <br />
                    </div>
                    <div className="body center">
                      <h2 className="h2">도시가스요금 알림톡청구서 신청</h2>
                      <p className="p">■ 고객명 : {this.state.cust_nm}</p>
                      <p className="p">■ 고객번호 : {this.state.cust_no_mask}</p>
                      <br/>
                      <p className="p">다음 납기부터 알림톡청구서로 발송됩니다.</p>
                      <p className="p">기존의 종이청구서는 더 이상 발송되지 않습니다.</p>
                      <div className="c">
                      <ApplyTalkStyles variant="contained" color="primary" className={params.margin} type="submit">신청</ApplyTalkStyles>
                      </div>
                    </div>
                </form>
              )
            }
          }else{
            return(
              <>
                <div className="div_logo">
                    <br />
                    <img width='150' src={ImageLogo} alt="대륜이엔에스 로고입니다." />
                    <br />
                </div>
                <div className="body center">
                  <div>
                    <h2 className="h2">도시가스요금 알림톡청구서 신청</h2>
                    <h3 className="h3">&nbsp;등록 가능한 기간이 경과하였습니다.</h3>
                    <p>&nbsp;(등록기간 : 발송일로부터 7일 이내)</p>
                  </div>
                </div>
              </>
            );
          }
        }
      }
    }
};